import { AsyncPipe, NgClass, NgFor } from "@angular/common";
import { Component, inject } from "@angular/core";
import { ToastService } from "../core/toast.service";

@Component({
  selector: "app-toast-stack",
  standalone: true,
  imports: [AsyncPipe, NgClass, NgFor],
  template: `
    <div
      class="fixed right-4 top-4 z-[100] flex w-[min(24rem,calc(100vw-2rem))] flex-col gap-2"
    >
      <button
        type="button"
        *ngFor="let toast of toast.messages$ | async"
        (click)="toastService.dismiss(toast.id)"
        class="rounded-md border bg-card px-4 py-3 text-left text-sm text-card-foreground shadow-lg backdrop-blur-sm transition hover:translate-y-[-1px]"
        [ngClass]="{
          'border-accent/40': toast.kind === 'success',
          'border-destructive/40': toast.kind === 'error',
          'border-primary/40': toast.kind === 'info',
        }"
      >
        <span
          class="font-semibold"
          [ngClass]="{
            'text-accent': toast.kind === 'success',
            'text-destructive': toast.kind === 'error',
            'text-primary': toast.kind === 'info',
          }"
        >
          {{
            toast.kind === "success"
              ? "Success"
              : toast.kind === "error"
                ? "Error"
                : "Info"
          }}
        </span>
        <span class="mt-1 block text-muted-foreground">{{
          toast.message
        }}</span>
      </button>
    </div>
  `,
})
export class ToastStackComponent {
  readonly toast = inject(ToastService);
  readonly toastService = inject(ToastService);
}
